import React from 'react';
import { Text } from 'react-native';

//= ========================================================================

const Details = ({ children, marginBottom = 30, marginTop = 0 }) => (
  <Text style={{
    color: '#718096',
    marginBottom,
    marginTop,
  }}
  >
    {children}
  </Text>
);
export default Details;
